/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';

import {useEditContextNodeId, useEditFileUpload} from "../../../Hooks/PermissionHooks";


export const StreamBankEditableCheckerEnhance = ((ComposedComponent) => function StreamBankEditableCheckerEnhance(props) {
    const canEditContextNodeId = useEditContextNodeId();
    const canEditFileUpload = useEditFileUpload();

    return <ComposedComponent
        {...props}
        EditableChecker={{
            CanEditContextNodeId: canEditContextNodeId,
            CanEditFileUpload: canEditFileUpload
        }}
    />;
});
